var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15.626306 15.944539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-.683594 -.147461)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M16.3099 8.29692c0-.65552-.0532-1.13387-.1683-1.62993H8.65625v2.95866H13.05c-.0886.73525-.5669 1.84255-1.63 2.58665l-.0149.099 2.3668 1.8335.1639.0164c1.5059-1.3908 2.3741-3.4371 2.3741-5.86428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M8.65534 16.092c2.15256 0 3.95966-.7087 5.27956-1.9311l-2.5158-1.9489c-.6732.4695-1.57677.7973-2.76376.7973-2.10827 0-3.89765-1.3908-4.53551-3.31301l-.0935.00794-2.46094 1.90457-.03219.0894c1.31103 2.6044 4.00397 4.3938 7.12214 4.3938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M4.1206 9.69633c-.1683-.49606-.26571-1.0276-.26571-1.57679 0-.54925.09741-1.08073.25686-1.57679l-.00446-.10565L1.6155 4.50195l-.08152.03878C.99364 5.62146.683594 6.83508.683594 8.11954c0 1.28446.310046 2.49806.850386 3.57876z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb4335",
    d: "M8.65534 3.23015c1.49706 0 2.50686.64665 3.08266 1.18705l2.25-2.19688C12.6062.935858 10.8079.147461 8.65534.147461c-3.11817 0-5.81111 1.789369-7.12214 4.393709l2.57777 2.00202c.64672-1.92226 2.4361-3.31304 4.54437-3.31304Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.679688.147461h15.64v16h-15.64z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.ddb9a6293b7b10980578a74c83019fc5.svg";
export { ForwardRef as ReactComponent };